import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext.jsx";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { GetDataBusiness } from "../../../../api/GetData.jsx";
import { FaEye, FaEyeSlash, FaUser, FaLock, FaBuilding } from "react-icons/fa";
import { AuthKPI } from "../../../../api/PostData.jsx";

const Login = () => {
  useEffect(() => {
    document.title = "KPI Login";
  }, []);

  const { setAuthData, setBusiness: setBusinessContext } = useAuth();
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [business, setBusiness] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [dataBus, setDataBus] = useState([]);
  const [loadingBusiness, setLoadingBusiness] = useState(true);

  useEffect(() => {
    const savedUserName = localStorage.getItem("userName");
    const savedPassword = localStorage.getItem("password");

    if (savedUserName && savedPassword) {
      setUserName(savedUserName);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  useEffect(() => {
    const fetchDataBus = async () => {
      try {
        setLoadingBusiness(true);
        const response = await GetDataBusiness();
        setDataBus(response);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingBusiness(false);
      }
    };
    fetchDataBus();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!business || !userName || !password) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Semua field harus diisi!",
        confirmButtonColor: "#1e40af",
      });
      return;
    }

    handleLogin();
  };

  const handleLogin = async () => {
    try {
      setLoading(true);
      const authKPI = await AuthKPI({
        busCode: business,
        username: userName,
        password: password,
      });

      if (authKPI.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Login Berhasil",
          text: "Selamat datang di KPI Dashboard",
          confirmButtonColor: "#1e40af",
        });
        Cookies.set("token", authKPI.Token);
        setAuthData(authKPI.data);
        setBusinessContext(business);
        navigate("/kpi/dashboard");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        // title: "Login Gagal",
        title: error.response?.data?.message || "Cek username/password atau koneksi.",
        confirmButtonColor: "#1e40af",
      });
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <section className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('/img/pattern.svg')] opacity-10"></div>
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500/20 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-400/20 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>

        <div className="relative z-10 flex flex-col items-center justify-center w-full p-12 text-white">
          <img className="w-48 mb-8 drop-shadow-2xl" src="/img/MMG.png" alt="logo MMG" />
          <h1 className="text-4xl font-bold tracking-tight mb-4 text-center">MAJU MOTOR GROUP</h1>
          <p className="text-blue-200 text-lg text-center max-w-md">
            Key Performance Indicator Management System
          </p>
          <div className="mt-12 grid grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold">KPI</div>
              <div className="text-blue-300 text-sm">Dashboard</div>
            </div>
            <div>
              <div className="text-3xl font-bold">Real</div>
              <div className="text-blue-300 text-sm">Time Data</div>
            </div>
            <div>
              <div className="text-3xl font-bold">Pro</div>
              <div className="text-blue-300 text-sm">Analytics</div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex flex-col items-center mb-8">
            <img className="w-32 mb-4" src="/img/MMG.png" alt="logo MMG" />
            <h1 className="text-2xl font-bold text-blue-900">MAJU MOTOR GROUP</h1>
          </div>

          <div className="bg-white rounded-2xl shadow-xl shadow-blue-900/5 p-8 border border-slate-200/60">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-slate-800">Welcome Back</h2>
              <p className="text-slate-500 mt-1">Sign in to access KPI Dashboard</p>
            </div>

            <form className="space-y-5" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="business" className="block text-sm font-semibold text-slate-700 mb-2">
                  Business Unit
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaBuilding className="h-4 w-4 text-slate-400" />
                  </div>
                  <select
                    id="business"
                    className="block w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 appearance-none cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                    value={business}
                    onChange={(e) => setBusiness(e.target.value)}
                    disabled={loadingBusiness}
                  >
                    {loadingBusiness ? (
                      <option value="">Loading business data...</option>
                    ) : (
                      <>
                        <option value="">Select business unit</option>
                        {dataBus.map((item) => (
                          <option key={item.BusCode} value={item.BusCode}>
                            {item.BusName}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    {loadingBusiness ? (
                      <svg className="animate-spin h-4 w-4 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    ) : (
                      <svg className="h-4 w-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </div>
                </div>
              </div>

              <div>
                <label htmlFor="userName" className="block text-sm font-semibold text-slate-700 mb-2">
                  Username
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaUser className="h-4 w-4 text-slate-400" />
                  </div>
                  <input
                    type="text"
                    name="userName"
                    id="userName"
                    className="block w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="Enter your username"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-semibold text-slate-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaLock className="h-4 w-4 text-slate-400" />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder="Enter your password"
                    className="block w-full pl-10 pr-12 py-3 bg-slate-50 border border-slate-200 rounded-xl text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 transition-colors"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash className="h-4 w-4" /> : <FaEye className="h-4 w-4" />}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <label className="flex items-center cursor-pointer group">
                  <input
                    type="checkbox"
                    className="w-4 h-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500 focus:ring-2 transition-colors"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span className="ml-2 text-sm text-slate-600 group-hover:text-slate-800 transition-colors">
                    Remember me
                  </span>
                </label>
              </div>

              <button
                type="submit"
                disabled={loading || loadingBusiness}
                className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-xl shadow-lg shadow-blue-600/30 hover:shadow-blue-700/40 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:shadow-blue-600/30"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Signing in...
                  </span>
                ) : (
                  "Sign In"
                )}
              </button>
            </form>
          </div>

          <p className="text-center text-slate-500 text-sm mt-6">
            &copy; {new Date().getFullYear()} Maju Motor Group. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Login;
